import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { BRANDS_MAIN_PAGE } from "utils/constants/paths";

const BrandsMainPage = Loadable(React.lazy(() => import("./View")));

export const BrandsMainPageRoute: IRouteItem = {
  path: BRANDS_MAIN_PAGE,
  element: React.createElement(BrandsMainPage),
  name: "Brands Main Page",
};
